/* tslint:disable */
export const presaleABI = require(`@/abi/presale.json`);

export const alpaTokenABI = require(`@/abi/alpaToken.json`);

export const alpacaABI = !!process.env.VUE_APP_BSC
  ? require(`@/abi/cryptoAlpacaBSC.json`)
  : require(`@/abi/cryptoAlpaca.json`);

export const alpaRewardABI = require(`@/abi/alpaReward.json`);

export const tokenPresaleABI = require(`@/abi/tokenPresale.json`);

export const tokenPresaleWLABI = require(`@/abi/tokenPresale.json`);

export const masterChefABI = !!process.env.VUE_APP_BSC
  ? require(`@/abi/masterChefBSC.json`)
  : require(`@/abi/masterChef.json`);

export const fakeLPABI = !!process.env.VUE_APP_BSC
  ? require(`@/abi/fakeLPBSC.json`)
  : require(`@/abi/fakeLP.json`);

export const LPABI = require(`@/abi/LP.json`);

export const alpaSupplierABI = !!process.env.VUE_APP_BSC
  ? require(`@/abi/alpaSupplierBSC.json`)
  : require(`@/abi/alpaSupplier.json`);

export const alpacaSquadABI = !!process.env.VUE_APP_BSC
  ? require(`@/abi/alpacaSquadBSC.json`)
  : require(`@/abi/alpacaSquad.json`);

export const alpaFireABI = require(`@/abi/alpaFire.json`);

export const woolTokenABI = require(`@/abi/woolToken.json`);

export const alpacaRecycleBoxABI = require(`@/abi/alpacaRecycleBox.json`);

export const alpacaExchangeABI = require(`@/abi/alpacaExchange.json`);

export const woolRewardABI = require(`@/abi/woolReward.json`);

export const alpacaGrassABI = require(`@/abi/alpacaGrass.json`);

export const woolAirdropABI = require(`@/abi/woolAirdrop.json`);

export const alpacaPresaleBSCABI = require(`@/abi/alpacaPresaleBSC.json`);

export const wearableABI = require(`@/abi/wearable.json`);

export const wearableOperatorABI = require(`@/abi/wearableOperator.json`);

export const alpacaTailorABI = require(`@/abi/alpacaTailor.json`);

export const wearableRewardABI = require(`@/abi/wearableReward.json`);

export const soloBankABI = require(`@/abi/soloBank.json`);

export const pairABI = require(`@/abi/pair.json`);

export const tokenABI = require(`@/abi/token.json`);
